export default __webpack_public_path__ + "static/media/MightyMagnets_11.b78a0d54.png";